<template>
    <LateralElement :item="fichas" :drawer="drawer"></LateralElement>
</template>

<script>
import LateralElement from './LateralElement'

export default {
  props: {
    drawer: Boolean
  },

  components: {
    LateralElement
  },

  data () {
    return {
      fichas: { title: 'Información de clubes', icon: 'assignment', action: 'fichas' }
    }
  },

  methods: {
    expandLateralNav () {
      this.$store.commit('changeLateralNav')
    }
  }
}
</script>
